'use strict';

class AutoridadBeneficiariaController {
  constructor(DataService, Util, Proyecto, Message) {
    'ngInject';
    this.DataService = DataService;
    this.Util = Util;
    this.Proyecto = Proyecto;
    this.Message = Message;
  }

  $onInit() {
    this.config = {
      autoridad: false,
      modificar: false,
    };

    if (this.Util.isEmpty(this.proyecto.autoridad_beneficiaria)) {
      this.proyecto.autoridad_beneficiaria = {};
    }
  }

  $doCheck() {
    if (this.proyecto) {
      if (!this.config.autoridad && this.proyecto.autoridad_beneficiaria && this.proyecto.autoridad_beneficiaria.numero_documento) {
        this.proyecto.autoridad_beneficiaria.cargo = this.proyecto.cargo_autoridad_beneficiaria;
        this.proyecto.autoridad_beneficiaria.fax = this.proyecto.fax_autoridad_beneficiaria;
        this.config.autoridad = angular.copy(this.proyecto.autoridad_beneficiaria);
        this.config.autoridad.id_persona = this.proyecto.fid_autoridad_beneficiaria;
      }
    }
  }

  modificarUsuarioGAM() {
    this.modoVista = false;
    this.config.modificar = true;
  }
  modificarCancelado() {
    this.modoVista = true;
    this.config.modificar = false;
    this.proyecto.autoridad_beneficiaria = angular.copy(this.config.autoridad);
    this.proyecto.cargo_autoridad_beneficiaria = this.config.autoridad.cargo;
    this.proyecto.fax_autoridad_beneficiaria = this.config.autoridad.fax;
  }
  GuardarUsuarioGAM() {
    let datos = angular.copy(this.proyecto.autoridad_beneficiaria);
    datos.cargo = this.proyecto.cargo_autoridad_beneficiaria;
    datos.fax = this.proyecto.fax_autoridad_beneficiaria;
    datos.anterior = this.config.autoridad;
    this.DataService.put(`proyectos/${this.proyecto.id_proyecto}/autoridad_beneficiaria`, datos).then(resp=>{
      if (resp && resp.finalizado) {
        this.Message.success(resp.mensaje);
        this.modoVista = true;
        this.config.modificar = false;
      }
    });
  }

}

export default AutoridadBeneficiariaController;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/autoridad-beneficiaria/autoridad-beneficiaria.controller.js